import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LoginDialog from "./LoginDialog";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import Footer from "../components/Footer";
import LanguageDialog from "../components/LanguageDialog";
import SideNavDrawer from "../components/SideNavDrawer";
import FooterNew from "../components/FooterNew";
import Profile from "./Profile";
import Loader from "../components/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaTelegram } from "react-icons/fa";
import { isEmpty } from "lodash";
const Layout = ({ children }) => {
  const { t } = useTranslation();
  const loginModalShow = useContextSelector(
    AuthContext,
    (ctx) => ctx.loginModalShow,
  );

  const setShowAccount = useContextSelector(
    AuthContext,
    (ctx) => ctx.setShowAccount,
  );
  const location = useLocation();
  const navigate = useNavigate();
  const spinUser = useContextSelector(AuthContext, (ctx) => ctx.user);
  const setLoginModalShow = useContextSelector(
    AuthContext,
    (ctx) => ctx.setLoginModalShow,
  );
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    setLoader(true);
    const timer = setTimeout(() => {
      setLoader(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [location]);
  const showAccount = useContextSelector(AuthContext, (ctx) => ctx.showAccount);
  const betLoader = useContextSelector(AuthContext, (ctx) => ctx.betLoader);
  const [language, setLanguage] = useState(false);
  const [sideBar, setSidebar] = useState(false);
  const [downloadBar, setDownloadBar] = useState(
    () => localStorage.getItem("hideDownloadBar") !== "true",
  );

  const closeDownloadBar = () => {
    setDownloadBar(false);
    localStorage.setItem("hideDownloadBar", "true");
  };

  const [icon, setIcon] = useState({});

  const getData = async () => {
    const { data } = await apiGet(apiPath?.getSetting);
    if (data?.success) {
      setIcon(data?.results);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  console.log(icon);
  return (
    <div
      data-app="true"
      className="v-application v-application--is-ltr theme--light"
      id="app"
      style={{ position: "relative" }}
    >
      {location?.pathname == "/" && !isEmpty(icon?.whatsappContent) && (
        <IoLogoWhatsapp
          size={40}
          color="green"
          style={{
            position: "fixed",
            right: "5%",
            bottom: "10%",
            zIndex: "9999999",
          }}
          onClick={() =>
            window.open(`https://wa.me/${icon?.whatsappContent}`, "_blank")
          }
        />
      )}
      {location?.pathname == "/" && !isEmpty(icon?.telegramContent) && (
        <FaTelegram
          size={40}
          color="#229ED9"
          style={{
            position: "fixed",
            right: "5%",
            bottom: "16%",
            zIndex: "9999999",
          }}
          onClick={() =>
            window.open(`https://t.me/${icon?.telegramContent}`, "_blank")
          }
        />
      )}
      {(betLoader || loader) && <Loader />}
      <div className="v-application--wrap">
        <div>
          {downloadBar && (
            <div className="row download-bar no-gutters">
              <button
                onClick={() => closeDownloadBar()}
                type="button"
                className="v-icon notranslate mr-2 v-icon--link mdi mdi-close theme--light"
              />
              <img
                width={32}
                height={32}
                src="../../assets/images/download-app.png"
                alt={t("DownloadAlt")}
                className="mr-2"
              />
              <div className="mr-1 col">
                <label>{t("DownloadAppVersion")}</label>
              </div>
              <button
                data-v-3b7d3367
                type="button"
                className="pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default download-bar-button subtitle-1"
              >
                <span className="v-btn__content">{t("DOWNLOAD")}</span>
              </button>
            </div>
          )}
          <header
            className={
              !downloadBar
                ? "v-sheet theme--light v-toolbar v-toolbar--dense full-width header-top elevation-3 "
                : "v-sheet theme--light v-toolbar v-toolbar--dense full-width header-top elevation-3 download-bar-height"
            }
            style={{ height: "45px" }}
          >
            <div className="v-toolbar__content" style={{ height: "48px" }}>
              <div className="row mobile">
                <div className="d-flex flex-grow-0 align-center col col-2">
                  <button
                    onClick={() => setSidebar(true)}
                    type="button"
                    className="v-app-bar__nav-icon v-btn v-btn--icon v-btn--round theme--light v-size--default white--text"
                    color="white"
                    height={18}
                    width={22}
                    style={{ height: "18px", width: "22px" }}
                  >
                    <span className="v-btn__content">
                      <i
                        aria-hidden="true"
                        className="v-icon notranslate mdi mdi-menu theme--light"
                      />
                    </span>
                  </button>
                </div>
                <div className="d-flex justify-space-around pt-2 col">
                  <a
                    href="/"
                    className="d-flex justify-center align-center router-link-exact-active router-link-active"
                  >
                    <img
                      width="100px"
                      src="../../assets/images/logo.png"
                      alt={t("LogoAltCricketExchange")}
                    />
                  </a>
                </div>
                <div className="d-flex align-center mobile-header-rightBtns col col-2">
                  {/**/}
                  {/**/}
                </div>
              </div>
              <div className="row hidden-sm-and-down header-top-desktop no-gutters">
                <div className="row col no-gutters">
                  <div className="row self-align no-gutters justify-start">
                    <a
                      href="/"
                      className="d-flex justiy-center router-link-exact-active router-link-active"
                    >
                      <img
                        height={48}
                        s
                        src="../../assets/images/logo.png"
                        alt={t("LogoAltExchange")}
                      />
                    </a>
                  </div>
                  <div className="row header-column no-gutters justify-end">
                    {/**/}
                    <div className="align-self-center col">
                      <div className="row d-md-none v-primary-base no-gutters justify-end">
                        <a className="d-flex flex-column justify-center align-center mr-3">
                          <i className="fas fa-language toolbar-icon" />
                          <div className="text-caption toolbar-caption">
                            {t("Language")}
                          </div>
                        </a>
                        <a className="d-flex flex-column justify-center align-center">
                          <i className="fas fa-sign-in-alt toolbar-icon" />
                          <div className="text-caption toolbar-caption">
                            {t("Login")}
                          </div>
                        </a>
                      </div>
                      <div className="row hidden-sm-and-down no-gutters justify-end">
                        <button
                          type="button"
                          className="mr-6 embedded-login-button text-capitalize v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                        >
                          <span className="v-btn__content">{t("Login")}</span>
                        </button>
                        <button
                          type="button"
                          className="mr-6 embedded-register-button white--text text-capitalize v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                        >
                          <span className="v-btn__content">{t("Singup")}</span>
                        </button>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="text-capitalize align-self-center white--text invisible-button v-btn v-btn--plain theme--light v-size--default"
                    >
                      <span className="v-btn__content">
                        <div
                          className="v-avatar language-button"
                          style={{
                            height: "24px",
                            "min-width": "24px",
                            width: "24px",
                          }}
                        >
                          <img
                            src="/static/image/country/BDT.svg"
                            alt={t("LogoAltExchange")}
                          />
                        </div>
                        <label>{t("BDTEnglish")}</label>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <SideNavDrawer open={sideBar} onClose={() => setSidebar(false)} />

          <div className="page-navigator hidden-sm-and-down">
            <div className="page-navigator-wrapper">
              <div className="page-navigator-item">
                <a
                  href="/winx9_2024_new.apk"
                  className="page-navigator-button v-btn v-btn--text theme--light v-size--default"
                >
                  <span className="v-btn__content">
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate material-icons theme--light"
                    >
                      system_update
                    </i>
                  </span>
                </a>
              </div>
              <div className="page-navigator-item">
                <a
                  href="/"
                  className="page-navigator-button page-navigator-button--active v-btn--active v-btn v-btn--router v-btn--text theme--light v-size--default"
                >
                  <span className="v-btn__content">
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate material-icons theme--light"
                    >
                      home
                    </i>
                  </span>
                </a>
              </div>
              <div className="page-navigator-item">
                <a
                  href="/cricket/"
                  className="page-navigator-button v-btn v-btn--router v-btn--text theme--light v-size--default"
                >
                  <span className="v-btn__content">
                    <label className="menu-navigator text-center text-capitalize">
                      {t("Cricket")}
                    </label>
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate material-icons theme--light"
                    >
                      keyboard_arrow_down
                    </i>
                  </span>
                </a>
                <div className="v-menu mt-2">{/**/}</div>
              </div>
              <div className="page-navigator-item">
                <a
                  href="/casino/"
                  className="page-navigator-button v-btn v-btn--router v-btn--text theme--light v-size--default"
                >
                  <span className="v-btn__content">
                    <label className="menu-navigator text-center text-capitalize">
                      {t("LiveCasino")}
                    </label>
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate material-icons theme--light"
                    >
                      keyboard_arrow_down
                    </i>
                  </span>
                </a>
                <div className="v-menu mt-2">{/**/}</div>
              </div>
              <div className="page-navigator-item">
                <a
                  href="/slot/"
                  className="page-navigator-button v-btn v-btn--router v-btn--text theme--light v-size--default"
                >
                  <span className="v-btn__content">
                    <label className="menu-navigator text-center text-capitalize">
                      {t("SlotGames")}
                    </label>
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate material-icons theme--light"
                    >
                      keyboard_arrow_down
                    </i>
                  </span>
                </a>
                <div className="v-menu mt-2">{/**/}</div>
              </div>
              <div className="page-navigator-item">
                <a
                  href="/tablegames/"
                  className="page-navigator-button v-btn v-btn--router v-btn--text theme--light v-size--default"
                >
                  <span className="v-btn__content">
                    <label className="menu-navigator text-center text-capitalize">
                      {t("TableGames")}
                    </label>
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate material-icons theme--light"
                    >
                      keyboard_arrow_down
                    </i>
                  </span>
                </a>
                <div className="v-menu mt-2">{/**/}</div>
              </div>
              <div className="page-navigator-item">
                <a
                  href="/sportsbook/"
                  className="page-navigator-button v-btn v-btn--router v-btn--text theme--light v-size--default"
                >
                  <span className="v-btn__content">
                    <label className="menu-navigator text-center text-capitalize">
                      {t("Sportbook")}
                    </label>
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate material-icons theme--light"
                    >
                      keyboard_arrow_down
                    </i>
                  </span>
                </a>
                <div className="v-menu mt-2">{/**/}</div>
              </div>
              <div className="page-navigator-item">
                <a
                  href="/fishing/"
                  className="page-navigator-button v-btn v-btn--router v-btn--text theme--light v-size--default"
                >
                  <span className="v-btn__content">
                    <label className="menu-navigator text-center text-capitalize">
                      {t("Fishing")}
                    </label>
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate material-icons theme--light"
                    >
                      keyboard_arrow_down
                    </i>
                  </span>
                </a>
                <div className="v-menu mt-2">{/**/}</div>
              </div>
              <div className="page-navigator-item">
                <a
                  href="/crash/"
                  className="page-navigator-button v-btn v-btn--router v-btn--text theme--light v-size--default"
                >
                  <span className="v-btn__content">
                    <label className="menu-navigator text-center text-capitalize">
                      {t("Crash")}
                    </label>
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate material-icons theme--light"
                    >
                      keyboard_arrow_down
                    </i>
                  </span>
                </a>
                <div className="v-menu mt-2">{/**/}</div>
              </div>
              <div className="page-navigator-item">
                <a
                  href="/promotion/"
                  className="page-navigator-button v-btn v-btn--router v-btn--text theme--light v-size--default"
                >
                  <span className="v-btn__content">
                    <label
                      className="text-center text-capitalize"
                      style={{ cursor: "pointer" }}
                    >
                      {t("Promotion")}
                    </label>
                  </span>
                </a>
              </div>
              <div className="page-navigator-item">
                <span right className="v-badge v-badge--overlap theme--light">
                  <a
                    href="/jayarank/challenge/"
                    className="page-navigator-button v-btn v-btn--router v-btn--text theme--light v-size--default"
                  >
                    <span className="v-btn__content">
                      <label
                        className="text-center text-capitalize"
                        style={{ cursor: "pointer" }}
                      >
                        {t("JayaRank")}
                      </label>
                    </span>
                  </a>
                  <span className="v-badge__wrapper">
                    <span
                      aria-atomic="true"
                      aria-label={t("Badge")}
                      aria-live="polite"
                      role="status"
                      className="v-badge__badge light"
                      style={{
                        inset: "auto auto calc(100% - 19px) calc(100% - 11px)",
                      }}
                    >
                      <div className="v-image v-responsive theme--light">
                        <div
                          className="v-image__image v-image__image--preload v-image__image--cover"
                          style={{ "background-position": "center center" }}
                        />
                        <div className="v-responsive__content" />
                      </div>
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div
            className={`body ${downloadBar ? "download-bar-height-body" : ""}`}
          >
            {children}
            <FooterNew />
          </div>
          {location?.pathname != "/register" && (
            <Footer setLanguage={setLanguage} />
          )}
        </div>
      </div>
      {location.pathname !== "/spin-wheel" && (
        <button
          type="button"
          onClick={() =>
            isEmpty(spinUser)
              ? setLoginModalShow(true)
              : navigate("/spin-wheel")
          }
          style={{
            position: "fixed",
            right: "1vw",
            bottom: "18vw",
            zIndex: 99,
            border: "none",
            background: "transparent",
            padding: 0,
            cursor: "pointer",
          }}
        >
          <img
            alt="spin"
            style={{ width: "16vw", height: "16vw" }}
            src="/img/wofSpin.webp"
          />
        </button>
      )}
      {showAccount && <Profile onClose={() => setShowAccount(false)} />}
      {loginModalShow && <LoginDialog />}
      {language && <LanguageDialog setLanguage={setLanguage} />}
      {(loginModalShow || language) && (
        <div
          className="v-overlay v-overlay--active theme--dark"
          style={{ "z-index": "201" }}
        >
          <div
            className="v-overlay__scrim"
            style={{
              opacity: "0.46",
              "background-color": "rgb(33, 33, 33)",
              "border-color": "rgb(33, 33, 33)",
            }}
          />
          <div className="v-overlay__content" />
        </div>
      )}
    </div>
  );
};

export default Layout;
